import React, { Component } from 'react'
import { MessageComponentProps, MessageBubbleText, FirebaseMessage } from '@deal/chat-firebase'
import { Button, PhoneField } from '@deal/components'
import { AnalyticsConsumer } from '#src/containers/Analytics'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { isValidPhoneNumber } from '#src/services/phone'
import Check from './check.svg'
import {
  ContactCollectionUpdatePhoneComponent,
  ChatLeadComponent,
  MessageRichCardType,
  ContactType
} from '#src/generated/graphql'

import styles from './styles.css'

interface State {
  phoneNumber?: string
  isPhoneNumberValid: boolean
}

export default class ContactCollection extends Component<MessageComponentProps, State> {
  constructor(props: MessageComponentProps) {
    super(props)

    this.state = {
      phoneNumber: '',
      isPhoneNumberValid: false
    }

    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this)
  }

  public static handlesMessage(message: FirebaseMessage) {
    return (
      message.parts[0].body.richCardType === MessageRichCardType.CONTACT_COLLECTION_REQUEST &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.leadId
    )
  }

  public handlePhoneNumberChange(value: string) {
    this.setState({
      phoneNumber: value,
      isPhoneNumberValid: isValidPhoneNumber(value)
    })
  }

  public render() {
    const leadId = this.props.message.parts[0].body.queryVariables.leadId
    const textPortion = this.props.message.parts.find(part => part.type === 'TEXT')

    return (
      <ChatLeadComponent variables={{ leadId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.lead) {
            const { expert, consumer } = data.lead

            const consumerHasPhone = consumer.contacts.find(
              contact => contact.type === ContactType.PHONE
            )

            return (
              <AnalyticsConsumer>
                {analytics => (
                  <>
                    {textPortion ? (
                      <MessageBubbleText myself={this.props.myself} message={this.props.message}>
                        {textPortion.body.text}
                      </MessageBubbleText>
                    ) : (
                      <MessageBubbleText myself={this.props.myself} message={this.props.message}>
                        {consumer.firstName ? `Hey ${consumer.firstName}! ` : `Hey! `} Enjoying your
                        conversation{expert.firstName ? ` with ${expert.firstName}?` : '?'} Get
                        their help on go - anytime you want! You can turn off text alerts anytime by
                        replying STOP
                      </MessageBubbleText>
                    )}

                    <div className={styles.phoneForm}>
                      {consumerHasPhone ? (
                        <>
                          <div className={styles.successFormContent}>
                            <div className={styles.phoneFormIcon}>
                              <Check width={32} height={32} />
                            </div>
                            <div className={styles.phoneFormHeader}>
                              Success! Text messaging enabled
                            </div>
                            <div className={styles.followUp}>
                              Now you can call or text{' '}
                              {expert.firstName ? expert.firstName : 'your expert'} anytime,
                              anywhere
                            </div>
                          </div>
                          <div className={styles.followUpFooter}>
                            You can update notification preferences and any information directly
                            from your{' '}
                            <Link to="/account" className={styles.followUpLink}>
                              Curated account
                            </Link>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className={styles.phoneFormContent}>
                            <div className={styles.phoneFormHeader}>Enter your phone number</div>
                            <div className={styles.phone}>
                              <PhoneField
                                label=""
                                errorText={
                                  !this.state.isPhoneNumberValid && this.state.phoneNumber !== ''
                                    ? 'Please enter a valid phone number'
                                    : undefined
                                }
                                labelHidden={true}
                                autoFocus={true}
                                onChange={e =>
                                  this.handlePhoneNumberChange(e.target.value.replace(/\D/g, ''))
                                }
                                placeholder="Phone number"
                              />
                            </div>
                            <div className={styles.terms}>
                              Message and data rates may apply. By submitting, you authorize
                              Curated.com to send you automated text messages to alert you of deals
                              and activity from your expert. You can turn off text alerts anytime by
                              replying STOP.
                            </div>
                          </div>
                          <ContactCollectionUpdatePhoneComponent
                            variables={{
                              input: {
                                phone: this.state.phoneNumber
                              }
                            }}
                            onCompleted={response => {
                              if (
                                response &&
                                response.updateUserProfile &&
                                response.updateUserProfile.errors.length > 0
                              ) {
                                toast.error(response.updateUserProfile.errors.join(', '))

                                return false
                              }

                              if (analytics) {
                                analytics.contactCollectionCardSubmitted()
                              }
                              toast.success('Successfully updated phone number.')
                            }}
                            onError={() => {
                              toast.error('Error updating your phone number! Please try again.')
                            }}
                          >
                            {(contactCollectionUpdatePhone, { loading }) => (
                              <Button
                                className={styles.submit}
                                onClick={() => contactCollectionUpdatePhone()}
                                disabled={!this.state.isPhoneNumberValid || loading}
                              >
                                Submit
                              </Button>
                            )}
                          </ContactCollectionUpdatePhoneComponent>
                        </>
                      )}
                    </div>
                  </>
                )}
              </AnalyticsConsumer>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading message!
              </MessageBubbleText>
            )
          }
        }}
      </ChatLeadComponent>
    )
  }
}
